import {createSvgIcon} from '../create-svg-icon';

export const Looks4Icon = createSvgIcon(
  <path d="M19.04 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-14V5h14v14zm-6-2h2V7h-2v4h-2V7h-2v6h4z" />
, 'Looks4Outlined');
